import appleLogo from "@assets/apple_logo.webp"
import googleLogo from "@assets/google_logo.webp"
import Button from "@components/Button"
import Input from "@components/Input"
import Layout from "@components/Layout"
import PageHeading from "@components/PageHeading"
import PasswordInput from "@components/PasswordInput"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Form, Link, useActionData, useNavigation } from "react-router-dom"
import { SignInActionData } from "src/actions/signInAction"

export default function SignInPage() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const signInActionData = useActionData() as SignInActionData
  const navigation = useNavigation()
  const { t } = useTranslation()

  const isSubmitting = ["loading", "submitting"].includes(navigation.state)

  const handleSignInWith = (provider: string) => {
    console.log("TODO: Sign in with:", provider)
  }

  return (
    <Layout>
      <div className="space-y-6 text-center">
        <PageHeading>{t("pages.account.signIn.heading")}</PageHeading>

        {signInActionData?.error && (
          <p className="custom-subheading-error">{signInActionData.error}</p>
        )}
      </div>

      <Form className="custom-form" method="post">
        <fieldset className="space-y-7" disabled={isSubmitting}>
          <Input
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("shared.email")}
            type="email"
            value={email}
          />

          <PasswordInput
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />

          <Link
            className="float-right mr-4 text-sm font-semibold text-gray-400 underline"
            to="/account/forgot-password"
          >
            {t("pages.account.signIn.forgotPassword")}
          </Link>
        </fieldset>

        <div className="mt-auto space-y-6 pt-6">
          <Button
            disabled={isSubmitting}
            type="submit"
            title={t("shared.signIn")}
          />

          {/* TODO: Implement social sign in */}
          {false && (
            <div className="space-y-7">
              <button
                className="custom-button-secondary"
                onClick={() => handleSignInWith("apple")}
              >
                <img src={appleLogo} alt="Apple logo" className="h-6 w-6" />
                {t("pages.account.signIn.signInWithApple")}
              </button>

              <button
                className="custom-button-secondary"
                onClick={() => handleSignInWith("google")}
              >
                <img src={googleLogo} alt="Google logo" className="h-6 w-6" />
                {t("pages.account.signIn.signInWithGoogle")}
              </button>
            </div>
          )}

          <div className="text-center">
            <Link className="text-lg font-semibold" to="/onboarding">
              {t("pages.account.signIn.signUp")}
            </Link>
          </div>
        </div>
      </Form>
    </Layout>
  )
}
